import { RangeDatepicker } from '@piccolohealth/ui';
import React from 'react';
import type { AuditTrailFilter } from '../../hooks/useAuditTrailFilter';

interface Props {
  filter: AuditTrailFilter;
}

export const AuditTrailDateFilterControl = ({ filter }: Props) => {
  const { startDateFilter, endDateFilter, onStartDateFilter, onEndDateFilter } = filter;

  return (
    <RangeDatepicker
      startDate={startDateFilter ?? null}
      endDate={endDateFilter ?? null}
      onStartDateChange={(date) => onStartDateFilter(date ?? undefined)}
      onEndDateChange={(date) => onEndDateFilter(date ?? undefined)}
      size='sm'
    />
  );
};
